import customerInfoDb from '../database/customerInfoDB';
import customerKeywordUploadDb from '../database/customerKeywordsUploadsDB';
import customerPageUploadDb from '../database/customerPagesUploadsDB';
import segmentDb from '../database/segmentDB';
import domainMKInfoSDb from '../database/domainMksInfoDB';

const fetchCustomerInfo = async (customerId) => {
  const customerStore = await customerInfoDb?.createCustomerStore(customerId);
  const masterData = await customerStore?.toArray();
  return masterData[0];
};

const fetchCustomerKeywordsUploads = async (customerId) => {
  const customerStore = await customerKeywordUploadDb?.createCustomerStore(customerId);
  const masterData = await customerStore?.toArray();
  return masterData[0];
};

const fetchCustomerPagesUploads = async (customerId) => {
  const customerStore = await customerPageUploadDb?.createCustomerStore(customerId);
  const masterData = await customerStore?.toArray();
  return masterData[0];
};

const fetchDomainMksInfo = async (customerId) => {
  const customerStore = await domainMKInfoSDb?.createCustomerStore(customerId);
  const masterData = await customerStore?.toArray();
  return masterData[0];
};

const fetchSegmentData = async (customerId) => {
  const customerStore = await segmentDb?.createCustomerStore(customerId);
  const masterData = await customerStore?.toArray();
  return masterData[0];
};

export {
  fetchCustomerInfo,
  fetchCustomerKeywordsUploads,
  fetchCustomerPagesUploads,
  fetchDomainMksInfo,
  fetchSegmentData,
};
